import { mapGetters } from "vuex";
import QuickMenuLink from "./../../quick-menu-link/QuickMenuLink";

const quickMenuMixin = {
  components: { QuickMenuLink },
  computed: {
    ...mapGetters({
      menu: "vendor/getVendorMenu",
      accentColor: "theme/getAccentColor"
    })
  }
};

export default quickMenuMixin;
